import { deleteCookie } from "cookies-next";
import store from "store";
export const resetSession = () => {
  store.remove("cart");
  store.remove("checkout");
  deleteCookie("quote");
  deleteCookie("mage");
};
